export class User {
    userId: string;
    parentUserId: string;
    role: string;
    emailAddress: string;
    firstName: string;
    lastName: string;
    phoneNumber: string;
    hasCompletedRegistration: boolean;
    permissions: string[];
}

export class UserAddress {
    street: string;
    postalCode: string;
    city: string;
    country: string;
    // This is a placeholder based on the empty object provided.
    // You can add properties like street, city, state, zipCode later.
}

export class UserCompany {
    name: string;
    taxId: string;
    street: string;
    postalCode: string;
    city: string;
    state: string;
    country: string;
}

export class GeneralSettings {
    scheme: 'light' | 'dark';
}

export class Settings {
    general: GeneralSettings;
}

export interface IBankAccount {
    // Define properties for a bank account, e.g., accountId, bankName, etc.
}

export interface UserSubscription {
    stripeCustomerId?: string;
    plan?: string | null;
    subscriptionId?: string;
    subscriptionStatus?: string;
    subscriptionCurrentPeriodEnd?: Date;
    trialEndsAt?: Date;
}

export class UserSettings {
    user: User;
    subscription: UserSubscription;
    address: UserAddress;
    company: UserCompany;
    bankAccounts: IBankAccount[];
    settings: Settings;
}